import React from 'react';
import { SortableElement, SortableHandle } from '../drag-and-drop';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const SortableItem = ({
  children,
  columnId,
  className
}, ref) => /*#__PURE__*/_jsx("div", {
  ref: ref,
  className: className,
  "data-column-id": columnId,
  children: children
});

const SortableElementItem = SortableElement( /*#__PURE__*/React.forwardRef(SortableItem));

const DragHandleContainer = ({
  children
}, ref) => /*#__PURE__*/_jsx("span", {
  ref: ref,
  children: children
});

const SortableDragHandle = SortableHandle( /*#__PURE__*/React.forwardRef(DragHandleContainer));

const HeaderCellContainer = ({
  index,
  column,
  tableManager
}) => {
  let {
    config: {
      isHeaderSticky,
      components: {
        DragHandle
      },
      additionalProps: {
        headerCellContainer: additionalProps = {}
      },
      icons: {
        sortAscending: sortAscendingIcon,
        sortDescending: sortDescendingIcon
      }
    },
    sortApi: {
      sort,
      toggleSort
    },
    columnsApi: {
      visibleColumns
    },
    config: {
      enableColumnsReorder
    },
    columnsResizeApi: {
      useResizeRef
    },
    rowSelectionApi: {
      selectAll: selectionProps
    }
  } = tableManager;
  let resizeHandleRef = useResizeRef(column);

  const getClassNames = () => {
    let classNames;

    switch (column.id) {
      case 'virtual':
        classNames = `rgt-cell-header rgt-cell-header-virtual-col${isHeaderSticky ? ' rgt-cell-header-sticky' : ''}`.trim();
        break;

      default:
        classNames = `rgt-border-line rgt-cell-header rgt-cell-header-${column.id === 'checkbox' ? 'checkbox' : column.field}${column.sortable !== false && column.id !== 'checkbox' && column.id !== 'virtual' ? ' rgt-clickable' : ''}${column.sortable !== false && column.id !== 'checkbox' ? ' rgt-cell-header-sortable' : ' rgt-cell-header-not-sortable'}${isHeaderSticky ? ' rgt-cell-header-sticky' : ' rgt-cell-header-not-sticky'}${column.resizable !== false ? ' rgt-cell-header-resizable' : ' rgt-cell-header-not-resizable'}${column.searchable !== false && column.id !== 'checkbox' ? ' rgt-cell-header-searchable' : ' rgt-cell-header-not-searchable'}${isPinnedLeft ? ' rgt-cell-header-pinned rgt-cell-header-pinned-left' : ''}${isPinnedLeftSecondCol ? ' rgt-cell-header-pinned rgt-cell-header-pinned-left-2nd' : ''}${isPinnedRight ? ' rgt-cell-header-pinned rgt-cell-header-pinned-right' : ''} ${column.className}`.trim();
    }

    return (classNames.trim() + ' ' + (additionalProps.className || '')).trim();
  };

  const getAdditionalProps = () => {
    let mergedProps = { ...additionalProps
    };

    if (column.sortable) {
      let onClick = additionalProps.onClick;

      mergedProps.onClick = e => {
        toggleSort(column.id);
        onClick == null ? void 0 : onClick(e);
      };
    }

    return mergedProps;
  };

  let isPinnedRight = column.pinned && index === visibleColumns.length - 1;
  let isPinnedLeft = column.pinned && index === 0;
  let isPinnedLeftSecondCol = column.pinned && index === 1;
  let classNames = getClassNames();
  let innerCellClassNames = `rgt-cell-header-inner${column.id === 'checkbox' ? ' rgt-cell-header-inner-checkbox' : ''}${!isPinnedRight ? ' rgt-cell-header-inner-not-pinned-right' : ''}`;
  additionalProps = getAdditionalProps();
  let headerCellProps = {
    tableManager,
    column
  }; // const [optionsToggle, setOptionsToggle] = useState(false);
  // const onOptionsClick = (e) => {
  //   e.stopPropagation();
  //   setOptionsToggle((options) => !options);
  // };
  // const onPinLeftChange = (column, e) => {
  //   let columns = [...tableManager.columnsApi.columns];
  //   for (let col of columns) {
  //     if (col.id !== 'checkbox') {
  //       col.pinned = false;
  //     }
  //     if (col.id === column.id) {
  //       if (e.target.checked) {
  //         col.pinned = true;
  //       }
  //     }
  //   }
  //   columns.sort((a, b) => {
  //     if (a.id === 'checkbox') {
  //       return 0;
  //     }
  //     if (a.pinned < b.pinned) {
  //       return 1;
  //     }
  //     if (a.pinned > b.pinned) {
  //       return -1;
  //     }
  //     return 0;
  //   });
  //   tableManager.columnsApi.setColumns(columns);
  //   setOptionsToggle((options) => !options);
  // };
  // const onPinRightChange = (column, e) => {
  //   let columns = [...tableManager.columnsApi.columns];
  //   for (let col of columns) {
  //     if (col.id !== 'checkbox') {
  //       col.pinned = false;
  //     }
  //     if (col.id === column.id) {
  //       if (e.target.checked) {
  //         col.pinned = true;
  //       }
  //     }
  //   }
  //   columns.sort((a, b) => {
  //     if (a.id === 'checkbox') {
  //       return 0;
  //     }
  //     if (a.pinned < b.pinned) {
  //       return -1;
  //     }
  //     if (a.pinned > b.pinned) {
  //       return 1;
  //     }
  //     return 0;
  //   });
  //   tableManager.columnsApi.setColumns(columns);
  //   setOptionsToggle((options) => !options);
  // };

  return /*#__PURE__*/_jsx("div", {
    "data-column-id": column.id.toString(),
    ...additionalProps,
    className: classNames,
    children: column.id === 'virtual' ? null : /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsxs(SortableElementItem, {
        className: innerCellClassNames,
        index: index,
        disabled: !enableColumnsReorder || isPinnedLeft || isPinnedLeftSecondCol || isPinnedRight,
        columnId: column.id.toString(),
        collection: isPinnedLeft || isPinnedLeftSecondCol || isPinnedRight ? 0 : 1,
        children: [DragHandle && !isPinnedLeft && !isPinnedLeftSecondCol && !isPinnedRight ? /*#__PURE__*/_jsx(SortableDragHandle, {
          index: index,
          children: /*#__PURE__*/_jsx(DragHandle, {})
        }) : null, column.id === 'checkbox' ? column.headerCellRenderer({ ...headerCellProps,
          ...selectionProps
        }) : column.headerCellRenderer(headerCellProps), sort.colId !== column.id ? null : sort.isAsc ? /*#__PURE__*/_jsx("span", {
          className: "rgt-sort-icon rgt-sort-icon-ascending",
          children: sortAscendingIcon
        }) : /*#__PURE__*/_jsx("span", {
          className: "rgt-sort-icon rgt-sort-icon-descending",
          children: sortDescendingIcon
        })]
      }), column.resizable ? /*#__PURE__*/_jsx("span", {
        ref: resizeHandleRef,
        className: "rgt-resize-handle",
        onClick: event => {
          event.preventDefault();
          event.stopPropagation();
        }
      }) : null]
    })
  });
};

export default HeaderCellContainer;